export default "__VITE_ASSET__DShGZ_Fm__"